/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { auditLogListEntries } from "../../funcs/auditLogListEntries.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetAuditLogEntriesRequest$inboundSchema,
};

export const tool$auditLogListEntries: ToolDefinition<typeof args> = {
  name: "get-audit-log-entries",
  description:
    `Fetches audit log entries for a LaunchDarkly account. Use the \`spec\` parameter with format \`proj/<projectKey>:env/<envKey>:flag/<flagKey>\` to query a specific flag's change history (use \`env/*\` for all environments). The \`before\` and \`after\` parameters accept Unix epoch timestamps in milliseconds for date-range filtering. Returns at most 20 entries per call, ordered newest-first.
`,
  scopes: ["read"],
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await auditLogListEntries(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
